import { useContext } from 'react';
import RaffleContext from '../context/RaffleContext';

const useRaffles = (key) => {
  const raffles = useContext(RaffleContext);

  return key ? raffles[key] : raffles;
};

export default useRaffles;
